<template>
  <div>
    <div class="lang-box">
      <slot v-if="$slots.default"></slot>
      <div v-else class="lang-box__input">
        <el-input
          :type="type"
          v-model="inputValue"
          @input="handleChange"
          :placeholder="placeholder"
        />
      </div>
      <el-button
        type="primary"
        class="lang-box__edit"
        icon="el-icon-s-grid"
        plain
        @click="openDialog"
      />
    </div>
    <el-dialog
      :title="$t('sp-language-dialog.index.496426-0')"
      :visible.sync="showDialog"
      :before-close="handleClose"
    >
      <div class="content">
        <el-table
          ref="multipleTable"
          :row-key="getRowKeys"
          :data="listValue"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column prop="label" :label="$t('sp-language-dialog.index.496426-1')" />
          <el-table-column v-for="(item, index) in locales" :label="item[locale]" :key="index">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row[item.lable]"
                type="text"
                :placeholder="inputPlaceholder"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">{{
          $t('sp-language-dialog.index.496426-2')
        }}</el-button>
        <el-button size="small" type="primary" @click="fnConfirm">{{
          $t('sp-language-dialog.index.496426-3')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import fetch from '@/utils/fetch'
import { transLangListToAttrBag, transLangList } from '@/utils'
import { locales } from '@/i18n'
export default {
  name: 'SpLanguageDialog',
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    url: {
      type: String,
      require: true,
      default: ''
    },
    value: {
      type: [Array, String],
      // array 需要格式 [{key,value,label}]
      required: true
    },
    type: String,
    placeholder: String,
    keys: {
      type: String,
      require: true
    } // 额外接收的keys 逗号分隔
  },

  data() {
    return {
      inputValue: '', // 存放input
      listValue: [], // 存放数据结构
      locales,
      showDialog: false
    }
  },
  computed: {
    itemId() {
      return this.$route.params.itemId
    },
    isValueArray() {
      return Array.isArray(this.value)
    },
    locale() {
      return this.$i18n.locale
    },
    inputPlaceholder() {
      return this.$t('sp-language-dialog.index.496426-4') + this.label || ''
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (typeof newVal === 'string') {
          this.inputValue = newVal
        } else if (Array.isArray(newVal)) {
          this.listValue = newVal.map((item) => ({ ...item, [item.locale]: item.value }))
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleChange(value) {
      this.value = value
    },
    async openDialog() {
      if (!this.url) {
        this.$message.error('未绑定传入接口，请检查后重试')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '请求中，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      const { itemId } = this.$route.params

      let keys = this.keys.split(',') // 暂时逗号分隔 
      try {
        fetch({
          url: this.url,
          method: 'get',
          params: {
            // 'attribute_name': ['productNameShort'],
            'attribute_name': keys,
            'item_id': itemId
          }
        }).then((res) => {
          const { data } = res.data
          this.listValue = transLangList(data)
          loading.close()
          this.showDialog = true
        })
      } catch (error) {
        console.error('接口调用失败：', error)
        loading.close()
      }
    },
    handleClose() {
      this.showDialog = false
    },
    handleSelectionChange(selection) {
      // 处理表格选择变化
    },
    fnConfirm() {
      const list = transLangListToAttrBag(this.listValue, this.itemId)
      // this.showDialog = false;
      this.putFetchData(list)
    },
    async putFetchData(data) {
      fetch({
        url: this.url,
        method: 'put',
        params: data
      }).then((res) => {
        const { status } = res.data
        if (status) {
          this.$message.success('修改成功')
        }
        if (this.isValueArray) {
          // 将localValue转换为[{key, value, label}]格式并更新value
          const list = this.listValue.map((item) => ({
            key: item.key,
            value: item[this.locale],
            label: item.label
          }))
          this.$emit('update', list)
        } else {
          // 将localValue转换为字符串格式并更新value
          this.$emit('update', this.listValue[0][this.locale])
        }
        this.showDialog = false
      })
    },
    getRowKeys(row) {
      return row.key
    }
  }
}
</script>
<style lang="scss">
.lang-box {
  display: flex;
  align-items: flex-start;
  &__input {
    flex-grow: 1;
    line-height: 36px;
    .el-input {
      max-width: 100%;
    }
  }
  &__edit {
    margin: 0 4px;
    height: 36px;
  }
}
.el-dialog__body {
  padding-top: 0;
}
</style>
